import { bool, string } from "prop-types"
import Icon from "components/planning_center_icon"
import ManageCategoriesButton from "components/admin/events/manage_categories_button"
import { Menu, MenuButton, MenuList } from "@reach/menu-button"

const SettingsMenu = ({ isAdmin, churchCenterEventSort }) => {
  return (
    <Menu>
      <MenuButton className="app-btn btn2">
        <Icon symbol="general#cog" aria_label="Open settings menu" />
        <span data-reach-menu-button-toggle-icon="true">
          <Icon symbol="general#down-caret" />
        </span>
      </MenuButton>
      <MenuList css={{ width: 280 }}>
        <ManageCategoriesButton isAdmin={isAdmin} />
      </MenuList>
    </Menu>
  )
}

SettingsMenu.propTypes = {
  isAdmin: bool,
  churchCenterEventSort: string
}

export default SettingsMenu
